import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';

import Overlay from '../Widget/Overlay';
import OverlayPublisher from '../Widget/OverlayPublisher';
import OverlayPartner from '../Widget/OverlayPartner';
import OverlayVoteSmart from '../Widget/OverlayVoteSmart';
import WidgetHeader from '../Widget/WidgetHeader';

import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';
import { isLongText } from '../../components/Shared/commonFunctions';
import { MultiImageBlock } from '../../components/Image/MultiImageBlock';
import CssTransition from '../../components/Transition/CssTransition';
import FindLocalRepPopup from '../../components/LocalRep/FindLocalRepPopup';
import LocalRepAction from '../../components/LocalRep/LocalRepAction';
import { CountryContainer } from '../../components/LocalRep/LocalRep';
import ShareDrawer from '../../components/ShareDrawer';
import ToasterAlert from '../../components/Donation/ToasterAlert';
import { ImageBanner } from '../../components/Link/Components';

import { Container } from '../DefaultStyles/Details';
import {
    Body,
    Content,
    Description,
    Details,
    DetailsContainer,
    Footer,
    PeopleSigned,
    Title,
    CountryFlag
} from '../DefaultStyles/Shared';

import { isPortrait } from '../../utils/size';
import { pictureUrl } from '../../utils/imageLoading';
import { formatThousands, Placeholders } from '../../utils/fillDynamicText';
import { ActionTypes, CardTypes, SupportContactRepCountryCodes } from '../../utils/enums';
import {
    buildCachedAddress,
    relevantRepresentatives,
    joinEnglish,
    districtInfo
} from '../../utils/localRepresentative/parser';

import {
    triggerFindYourRep,
    hideFindRepPopup,
    loadLocalRep,
    goToFindLocalRep,
    selectAction
} from '../LocalRep/actions';

import {
    getRepStances,
    initiateRepStance,
    completeRepStance
} from '../RepStance/actions';

import {
    onGoToNextActionInsideCard,
    setOverlayPartnerVisible,
    onBackWithinCard,
    setExitingCardProps,
    getExitingCardProps,
} from '../Widget/actions';

import { copyFor, capitalization } from '../../copy/copy';
import { DefaultRepImageURL } from '../../containers/DefaultStyles/Shared';

import { getActionCompletedTime } from '../../utils/actionTiming';

import { completeGlobalFallbackMultiAction } from './actions';
import { trackCompleteGlobalFallbackAction } from './tracking';

export class SingleAction extends React.Component {
    componentDidMount = async () => {
        if (
            !this.props.localRepFound &&
            this.props.useLocalRepresentative &&
            !this.props.isLocalRepLoading
        ) {
            await this.props.loadLocalRep(
                this.props.endUserLocation,
                this.props.cachedAddress,
                this.props.representativeSearch,
                false,
                this.props.activeAction.type === 'email' ||
                this.props.activeAction.type === 'recordvideo'
            );
        }
    };

    buttonComponent() {
        return (
            <AutoScalingButtonSet>
                {this.props.actions.map(a => {
                    return (
                        <LocalRepAction
                            isLongText={
                                !isPortrait() &&
                                isLongText(this.props.cardTitle, 40) &&
                                isLongText(this.props.cardDescription, 90)
                            }
                            action={a}
                            customText={this.props.globalButtonText}
                            key={a.identifier}
                            onClick={() => {
                                if (this.props.unsupportedLocationCode){
                                    window.open('http://www.actionbutton.org/library/international', '_blank');
                                    this.props.trackCompleteGlobalFallbackAction();
                                    if (this.props.isMultiAction){
                                        this.props.completeGlobalFallbackMultiAction(a.identifier);
                                    }
                                    return;
                                }

                                this.props.setExitingCardProps(
                                    this.props.activeAction.type,
                                    this.props,
                                    this.props.activeAction
                                );

                                if (this.props.isRepStance) {
                                    this.props.initiateRepStance(a.identifier);
                                    if (!this.props.localRepFound)
                                        return this.props.triggerFindYourRep();
                                    if (this.props.repStances.length === 0) {
                                        this.props.getRepStances(
                                            this.props.representatives,
                                            this.props.questionText
                                        );
                                        this.props.completeRepStance(
                                            this.props.apiRequestData,
                                            this.props.repStanceActionCompletedTime(),
                                            a.identifier
                                        );
                                        return this.props.onGoToNextActionInsideCard(
                                            a.identifier,
                                            a.type,
                                            true,
                                            false
                                        );
                                    } else {
                                        this.props.completeRepStance(
                                            this.props.apiRequestData,
                                            this.props.repStanceActionCompletedTime(),
                                            a.identifier
                                        );
                                        return this.props.onGoToNextActionInsideCard(
                                            a.identifier,
                                            a.type,
                                            true,
                                            false
                                        );
                                    }
                                }

                                if (
                                    (this.props.localRepFound &&
                                        this.props.representatives.length) ||
                                    !a.useLocalRepresentative
                                ) {
                                    this.props.selectAction(a.identifier);
                                    return this.props.onGoToNextActionInsideCard(
                                        a.identifier,
                                        a.type,
                                        true,
                                        false
                                    );
                                } else {
                                    this.props.selectAction(a.identifier);
                                    this.props.goToFindLocalRep(a.identifier, a.type);
                                }
                            }}
                        />
                    );
                })}
            </AutoScalingButtonSet>
        );
    }
    overlayComponents() {
        return (
            <TransitionGroup>
                {this.props.showFindYouRepPopup && (
                    <CssTransition key="alert" in={this.props.showFindYouRepPopup}>
                        <FindLocalRepPopup
                            noBack={
                                this.props.isRepStance &&
                                this.props.representatives.length === 0
                            }
                            message={
                                this.props.popupErrorMessage &&
                                this.props.repStanceUnavailable
                                    ? this.props.popupErrorMessage
                                    : null
                            }
                            address={this.props.address}
                            submitting={this.props.isLocalRepPopupLoading}
                            hideFindRepPopup={this.props.hideFindRepPopup}
                            callback={
                                !this.props.isRepStance
                                    ? null
                                    : async () => {
                                          if (this.props.isRepStance) {
                                              this.props.selectAction(
                                                  this.props.actions[0].identifier
                                              );
                                              await this.props.completeRepStance(
                                                  this.props.apiRequestData,
                                                  this.props.repStanceActionCompletedTime(),
                                                  this.props.actions[0].identifier
                                              );
                                          }
                                      }
                            }
                            onSubmit={async () => {
                                this.props.setExitingCardProps(
                                    this.props.activeAction.type,
                                    this.props,
                                    this.props.activeAction
                                );
                                await this.props.loadLocalRep(
                                    this.props.endUserLocation,
                                    this.props.address,
                                    this.props.representativeSearch,
                                    true,
                                    this.props.activeAction.type === 'email' ||
                                    this.props.activeAction.type === 'recordvideo'
                                );
                                if (this.props.isRepStance) {
                                    this.props.getRepStances(
                                        this.props.representatives,
                                        this.props.questionText
                                    );
                                    this.props.onGoToNextActionInsideCard(
                                        this.props.actions[0].identifier,
                                        this.props.actions[0].type,
                                        true,
                                        false
                                    );
                                }
                                return;
                            }}
                        />
                    </CssTransition>
                )}
            </TransitionGroup>
        );
    }

    render() {
        const imageSources = this.props.useLocalRepresentative
            ? this.props.localRepImages.length > 0
                ? this.props.localRepImages
                : [DefaultRepImageURL(this.props.country)]
            : this.props.pictureUrl || [];

        return (
            <Container
                desktopLinkImage={
                    this.props.actionTypeSupportsVisualLink &&
                    !!this.props.desktopImageId &&
                    this.props.isVisualLink &&
                    !isPortrait()
                }
            >
                <Overlay />
                <OverlayPublisher />
                <OverlayPartner transitionType="right-to-left" />
                <OverlayVoteSmart transitionType="right-to-left" />
                <TransitionGroup>
                    {this.props.addressValidationError && (
                        <CssTransition key="alert" in={this.props.addressValidationError}>
                            <ToasterAlert content={this.props.addressValidationError} />
                        </CssTransition>
                    )}
                </TransitionGroup>
                <Body
                    className="body-msn-override"
                    isBlured={this.props.showFindYouRepPopup}
                >
                    <WidgetHeader />
                    <Content
                        flexGrow={
                            ![
                                ActionTypes.Poll,
                                ActionTypes.Quiz,
                                ActionTypes.Email,
                                ActionTypes.RecordVideo
                            ].includes(this.props.activeAction.type) &&
                            !this.props.unsupportedLocationCode
                        }
                        isContactAction={this.props.isContactAction}
                        useLocalRepresentative={this.props.useLocalRepresentative}
                        isSingleAction={this.props.actions.length === 1}
                    >
                        <Title
                            scaleFactor={
                                isPortrait() && this.props.isVisualLink ? 0.8 : 1
                            }
                            isShortText={!isLongText(this.props.cardTitle, 28)}
                            isLongText={isLongText(this.props.cardTitle, 60)}
                            isExtraLongText={isLongText(this.props.cardTitle, 90)}
                            isLocalRepLoading={this.props.isLocalRepLoading}
                            onClick={e =>
                                this.props.setOverlayPartnerVisible(true, e, false)
                            }
                            dangerouslySetInnerHTML={{
                                __html: this.props.cardTitle
                            }}
                        />
                        <DetailsContainer singleImage={imageSources.length === 1}>
                            {this.props.isContactAction &&
                                this.props.unsupportedLocationCode ?
                                <CountryFlag
                                    countryCode={this.props.unsupportedLocationCode}
                                /> :
                                <MultiImageBlock
                                    className="ie-multi-image-block-fix"
                                    size={!this.props.localRepFound && 100}
                                    isLongTitle={isLongText(this.props.cardTitle, 40)}
                                    isLocalRepLoading={this.props.isLocalRepLoading}
                                    imgSources={imageSources}
                                />
                            }
                            <Details
                                isRepStance={this.props.isRepStance}
                                hasPhoto={
                                    this.props.isContactAction &&
                                    (this.props.useLocalRepresentative ||
                                        this.props.pictureUrl)
                                }
                                style={this.props.detailsStyles}
                            >
                                {this.props.cardDescription.length > 0 && (
                                    <Description
                                        className="ie-single-action-details-description"
                                        scaleFactor={
                                            isPortrait() && this.props.isVisualLink
                                                ? 0.8
                                                : 1
                                        }
                                        bold={
                                            this.props.useLocalRepresentative ||
                                            this.props.pictureUrl
                                        }
                                        isLocalRepLoading={this.props.isLocalRepLoading}
                                        dangerouslySetInnerHTML={{
                                            __html: this.props.cardDescription
                                        }}
                                        isSingleAction={this.props.actions.length === 1}
                                        isLongText={isLongText(
                                            this.props.cardDescription,
                                            90
                                        )}
                                        isExtraLongText={isLongText(
                                            this.props.cardDescription,
                                            160
                                        )}
                                        onClick={e =>
                                            this.props.setOverlayPartnerVisible(
                                                true,
                                                e,
                                                false
                                            )
                                        }
                                    />
                                )}
                                {!!this.props.noOfAnswers && this.props.showNoOfAnswers && (
                                    <PeopleSigned>
                                        {this.props.noOfAnswers}{' '}
                                        {copyFor(
                                            'miscellaneous',
                                            'numAnswered',
                                            this.props.activeAction.type,
                                            capitalization.all
                                        )}
                                    </PeopleSigned>
                                )}
                        {this.props.unsupportedLocationCode &&
                        <CountryContainer onClick={this.props.triggerFindYourRep} />}
                            </Details>
                        </DetailsContainer>
                    </Content>
                    {this.buttonComponent()}
                    {this.props.actionTypeSupportsVisualLink &&
                        this.props.isVisualLink && (
                            <ImageBanner
                                desktopImageId={this.props.desktopImageId}
                                mobileImageId={this.props.mobileImageId}
                            />
                        )}
                    <Footer>
                        <ShareDrawer
                            multipleReps={this.props.representatives.length > 1}
                            newsletterSignUpVisible={
                                (this.props.useLocalRepresentative &&
                                    this.props.localRepFound) ||
                                this.props.activeAction.type ===
                                    ActionTypes.CheckRepPosition ||
                                (this.props.activeAction.type === ActionTypes.Tweet &&
                                    this.props.useLocalRepresentative)
                                    ? false
                                    : true
                            }
                            beforeBack={() => {
                                this.props.setExitingCardProps(
                                    this.props.activeAction.type,
                                    this.props,
                                    this.props.activeAction
                                );
                            }}
                            goBack={() => {
                                return this.props.card.type === CardTypes.actionChoice
                                    ? this.props.onBackWithinCard(
                                          this.props.actionIdentifier,
                                          this.props.card,
                                          true
                                      )
                                    : null;
                            }}
                            fullwidth={
                                this.props.card.type === CardTypes.actionChoice ||
                                [
                                    ActionTypes.Call,
                                    ActionTypes.Email,
                                    ActionTypes.SentimentPoll,
                                    ActionTypes.CheckRepPosition,
                                    ActionTypes.Petition,
                                    ActionTypes.RecordVideo
                                ].includes(this.props.activeAction.type)
                            }
                            hasBackButton={
                                this.props.card.type === CardTypes.actionChoice
                            }
                            backgroundColor={'#fff'}
                        />
                    </Footer>
                </Body>
                {this.overlayComponents()}
            </Container>
        );
    }
}

SingleAction.propTypes = {
    actionIdentifier: PropTypes.string.isRequired,
    actions: PropTypes.array.isRequired,
    actionTypeSupportsVisualLink: PropTypes.bool.isRequired,
    activeAction: PropTypes.object.isRequired,
    address: PropTypes.object.isRequired,
    addressValidationError: PropTypes.any,
    apiRequestData: PropTypes.object.isRequired,
    cachedAddress: PropTypes.object,
    card: PropTypes.object.isRequired,
    cardDescription: PropTypes.string.isRequired,
    cardTitle: PropTypes.string.isRequired,
    completeRepStance: PropTypes.func.isRequired,
    country: PropTypes.string,
    desktopImageId: PropTypes.string,
    endUserLocation: PropTypes.object,
    getRepStances: PropTypes.func.isRequired,
    goToFindLocalRep: PropTypes.func.isRequired,
    hideFindRepPopup: PropTypes.func.isRequired,
    initiateRepStance: PropTypes.func.isRequired,
    isContactAction: PropTypes.bool,
    isLocalRepLoading: PropTypes.bool,
    isLocalRepPopupLoading: PropTypes.bool.isRequired,
    isRepStance: PropTypes.bool.isRequired,
    isVisualLink: PropTypes.bool,
    loadLocalRep: PropTypes.func.isRequired,
    localRepFound: PropTypes.bool.isRequired,
    localRepImages: PropTypes.array.isRequired,
    mobileImageId: PropTypes.string,
    noOfAnswers: PropTypes.string.isRequired,
    onBackWithinCard: PropTypes.func.isRequired,
    triggerFindYourRep: PropTypes.func.isRequired,
    onGoToNextActionInsideCard: PropTypes.func.isRequired,
    pictureUrl: PropTypes.array,
    popupErrorMessage: PropTypes.string,
    questionText: PropTypes.string,
    representatives: PropTypes.array,
    representativeSearch: PropTypes.object,
    repStanceActionCompletedTime: PropTypes.func.isRequired,
    repStances: PropTypes.arrayOf(PropTypes.object),
    repStanceUnavailable: PropTypes.bool,
    selectAction: PropTypes.func.isRequired,
    setExitingCardProps: PropTypes.func.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    showFindYouRepPopup: PropTypes.bool.isRequired,
    showNoOfAnswers: PropTypes.bool,
    useLocalRepresentative: PropTypes.bool
};

export const parseSingleActionProps = (state, props) => {
    const activeAction = state.widget.activeAction;
    const isRepStance = activeAction.type === ActionTypes.CheckRepPosition;
    const representativeSearch = state.widget.maximumRepresentativeSearch;
    const defaultRepSearch = state.repStance.defaultRepSearch;

    let reps = state.localRep.localRepData
        ? relevantRepresentatives(
              isRepStance
                  ? defaultRepSearch
                  : state.widget.activeAction.representativeSearch,
              state.localRep.localRepData.representative
          )
        : [];
    const country = ((state.localRep.localRepData || {}).address || {}).country;
    const contactKey =
        state.widget.activeAction.type === 'email' ||
        state.widget.activeAction.type === 'recordvideo'
            ? 'canBeEmailed'
            : state.widget.activeAction.type === 'call'
            ? 'phone'
            : 'fullName';
    const contactableReps = reps.filter(rep => !!rep[contactKey]);
    if (contactableReps.length) reps = contactableReps;
    reps = reps.slice(0, 3);

    const currActionChoiceIndex = state.actionChoiceCard.activeCarouselActionIndex;
    const currCard = state.widget.cards[state.widget.activeAction.order - 1];

    let currCardTitle =
        currCard.type === CardTypes.actionChoice
            ? state.widget.activeAction.name || currCard.heading || ''
            : currCard.heading || state.widget.activeAction.name || '';
    let currCardDescription =
        currCard.type === CardTypes.actionChoice
            ? state.widget.activeAction.description || currCard.subHeading || ''
            : currCard.subHeading || state.widget.activeAction.description || '';

    if (state.widget.activeAction.type === "recordvideo"){
        const isRepContactAction = state.widget.activeAction.representativeSearch
        currCardTitle = state.widget.activeAction.title || copyFor('create', 'title', 'recordvideo')
        currCardDescription = state.widget.activeAction.description || copyFor('create'+(isRepContactAction ? 'Reps' : ''), 'description', 'recordvideo')
    }

    const useLocalRepresentative = !!state.widget.activeAction.representativeSearch || isRepStance;
    const localRepData = state.localRep.localRepData || {};
    const repDistrict = localRepData.district || 'your district';
    const repState = localRepData.stateName || 'your state';
    const endUserLocation = state.widget.endUserLocation || {};

    const unsupportedLocationCode =
            useLocalRepresentative &&
            !localRepData.address &&
            !SupportContactRepCountryCodes.includes(endUserLocation.countryCode) &&
            endUserLocation.countryCode;
    let globalButtonText;
    if (unsupportedLocationCode){
        currCardTitle = copyFor('global','title');
        currCardDescription = copyFor('global','description')
                                .replace('@country', endUserLocation.countryName)
        globalButtonText = copyFor('global','button');
    }

    return {
        repDistrict,
        repState,
        globalButtonText,
        apiRequestData: state.widget.apiRequestData,
        address: state.form.google_autocomplete
            ? state.form.google_autocomplete.values
            : {},
        addressValidationError: state.widget.addressValidationError,
        actionIdentifier: state.widget.activeAction.identifier,
        repStanceActionCompletedTime: getActionCompletedTime(state, 'repStance'),
        activeAction,
        card: state.widget.cards[state.widget.activeAction.order - 1],
        country,
        desktopImageId: state.widget.activeAction.desktopImageId,
        mobileImageId: state.widget.activeAction.mobileImageId,
        isLocalRepLoading: state.localRep.isLocalRepLoading,
        localRepFound: state.localRep.localRepData.representative !== undefined,
        localRepImages: reps.map(rep => rep.photoUrl || DefaultRepImageURL(country)),
        isLocalRepPopupLoading: state.localRep.isLocalRepPopupLoading,
        isVisualLink: state.widget.activeAction.isVisual,
        actionTypeSupportsVisualLink:
            state.widget.activeAction.type === ActionTypes.Poll ||
            state.widget.activeAction.type === ActionTypes.Quiz,
        pictureUrl: pictureUrl(state),
        representatives: reps,
        representativeSearch,
        showFindYouRepPopup: state.localRep.showFindYouRepPopup,
        cardTitle: currCardTitle
            .replace(/@articleUrl/g, state.widget.articleUrl)
            .replace(
                new RegExp(Placeholders.PostalCodePlaceholder, 'g'),
                state.localRep.localRepData.representative !== undefined
                    ? (state.localRep.localRepData.address || {}).zipCode
                    : ''
            )
            .replace(
                new RegExp(
                    state.widget.activeAction.type === 'tweet'
                        ? Placeholders.TwitterMentionPlaceholder
                        : Placeholders.LocalRepresentative,
                    'g'
                ),
                reps.length > 0
                    ? joinEnglish(
                          reps.map(rep => `${rep.displayName}${districtInfo(rep)}`)
                      )
                    : `your legislators`
            )
            .replace(
                new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                state.localRep.localRepData.representative !== undefined
                    ? joinEnglish(reps.map(rep => rep.fullName || rep.twitterMention))
                    : '@Speakable'
            )
            .replace(new RegExp(Placeholders.StatePlaceholder, 'g'), repState)
            .replace(new RegExp(Placeholders.DistrictPlaceholder, 'g'), repDistrict),
        useLocalRepresentative,
        isContactAction: [
            ActionTypes.Email,
            ActionTypes.Tweet,
            ActionTypes.Call,
            ActionTypes.Petition,
            ActionTypes.RecordVideo
        ].includes(activeAction.type),
        regularRowSize: state.widget.regularRowSize,
        noOfAnswers: !!activeAction.noOfAnswers
            ? formatThousands(activeAction.noOfAnswers)
            : null,
        actions: state.widget.actions
            .filter(a => {
                return currCard.type === CardTypes.actionChoice
                    ? a.id === currCard.actions[currActionChoiceIndex].id
                    : a.id === state.widget.activeAction.id;
            })
            .map(a => {
                const label = !!a.customButtonText
                    ? a.customButtonText
                    : copyFor('buttons', 'start', a.type);
                return {
                    label,
                    identifier: a.identifier,
                    type: a.type,
                    name: a.name,
                    useLocalRepresentative: !!a.representativeSearch,
                    position: state.widget.cards[
                        state.widget.activeAction.order - 1
                    ].actions.indexOf(a)
                };
            })
            .slice(0, 1),
        cardDescription: currCardDescription
            .replace(new RegExp(Placeholders.ArticleUrl, 'g'), state.widget.articleUrl)
            .replace(
                new RegExp(Placeholders.PostalCodePlaceholder, 'g'),
                state.localRep.localRepData.representative !== undefined
                    ? (state.localRep.localRepData.address || {}).zipCode
                    : ''
            )
            .replace(
                new RegExp(
                    state.widget.activeAction.type === 'tweet'
                        ? Placeholders.TwitterMentionPlaceholder
                        : Placeholders.LocalRepresentative,
                    'g'
                ),
                reps.length > 0
                    ? joinEnglish(
                          reps.map(rep => `${rep.displayName}${districtInfo(rep)}`)
                      )
                    : `your legislators`
            )
            .replace(
                new RegExp(Placeholders.TwitterMentionPlaceholder, 'g'),
                state.localRep.localRepData.representative !== undefined
                    ? joinEnglish(reps.map(rep => rep.fullName || rep.twitterMention))
                    : '@Speakable'
            )
            .replace(
                new RegExp(Placeholders.NumberOfAnswers, 'g'),
                formatThousands(state.widget.activeAction.noOfAnswers) || '121'
            )
            .replace(new RegExp(Placeholders.StatePlaceholder, 'g'), repState)
            .replace(new RegExp(Placeholders.DistrictPlaceholder, 'g'), repDistrict),
        showNoOfAnswers:
            activeAction.type === ActionTypes.Petition ||
            activeAction.type === ActionTypes.Quiz ||
            activeAction.type === ActionTypes.Poll,
        endUserLocation,
        unsupportedLocationCode,
        isRepStance,
        isMultiAction: state.multiActionsCard.wasStarted,
        repStances: state.repStance.stances,
        repStanceUnavailable: state.repStance.repStanceUnavailable,
        popupErrorMessage: state.repStance.popupErrorMessage,
        questionText: activeAction.questionText || '',
        cachedAddress: buildCachedAddress(
            state.form.google_autocomplete
                ? state.form.google_autocomplete.values
                : state.cachedFormData
        ),
        detailsStyles: props?.detailsStyles,
        trackCompleteGlobalFallbackAction: () => trackCompleteGlobalFallbackAction(state)
    };
};

export const requiredFunctionsForSingleAction = {
    completeRepStance,
    getRepStances,
    goToFindLocalRep,
    hideFindRepPopup,
    initiateRepStance,
    loadLocalRep,
    onBackWithinCard,
    completeGlobalFallbackMultiAction,
    triggerFindYourRep,
    onGoToNextActionInsideCard,
    selectAction,
    setOverlayPartnerVisible,
    setExitingCardProps
};

export default (type, customProps) =>
    connect(
        (state, props) => {
            const exitingProps = getExitingCardProps(
                type,
                ['/' + type + '/start'],
                props.location.pathname,
                state
            );
            if (exitingProps) return exitingProps;

            return parseSingleActionProps(state, customProps);
        },
        requiredFunctionsForSingleAction
    )(SingleAction);
